import * as React from 'react';
import { SVGProps } from 'react';

const IcExpand = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.125 2.5v8.75h-1.25v-7.5h-7.5V2.5h8.75ZM2.5 18.125v-8.75h1.25v7.5h7.5v1.25H2.5Z"
    />
  </svg>
);

export default IcExpand;
